import { IS_NEXT_PRODUCTION_BUILD_PHASE } from 'utility/constant';
import { isTruthy } from 'utility/functions';

export const getLoggingLevelTelemetry = (): number | undefined => {
  /*
   mapping server-side configuration --> https://www.npmjs.com/package/applicationinsights
   to client-side parameter -> @microsoft/applicationinsights-web
   
   
   process.env.APPLICATIONINSIGHTS_INSTRUMENTATION_LOGGING_LEVEL = 'NONE' | 'ERROR' | 'WARN' | 'INFO' | 'DEBUG' | 'VERBOSE' | 'ALL'
   to become :
              0 -> ALL iKey logging OFF
              1 -> : logs to iKey: severity >= CRITICAL
              2 -> : logs to iKey: severity >= WARNING  
  */

  // replaced at build-time by config task- start
  let INSTRUMENTATION_LOGGING_LEVEL = 'OFF';
  // replaced at build-time by config task - end

  switch (INSTRUMENTATION_LOGGING_LEVEL) {
    case 'NONE': {
      return 0;
    }
    case 'ERROR': {
      return 1;
    }
    case 'WARN': {
      return 2;
    }
    // case LoggingLevelEnum.info: { return undefined}
    // case LoggingLevelEnum.debuge: {return undefined}
    // case LoggingLevelEnum.verbose: {return undefined}
    default:
      return undefined;
  }
};

export const allowAppInsight = (): boolean => {
  const result = getLoggingLevelTelemetry();

  if (IS_NEXT_PRODUCTION_BUILD_PHASE) {
    console.log(' isTruthy(getLoggingLevelTelemetry()) ', result);
  }

  return isTruthy(result) /* !== NONE*/;
};
